<script>
import BaseRadioList from './BaseRadioList.vue';

export default {
  name: 'question-base-radio-list-api',
  extends: BaseRadioList,
  props: {
    convertKeysToNumbers: {
      type: Boolean,
      default: true,
    },
    searchType: {
      type: String,
      default: '',
    },
    payload: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      fields: ['field'],
      fieldOptions: [],
      otherOptions: [],
    };
  },
  created () {
    if (this.searchType) {
      this.onSearch();
    }
  },
  computed: {
    fieldGenericItems () {
      return [
        ...this.fieldOptions,
        this.helpers.otherOption('', this.optionsConfig.otherLabel),
      ];
    },
    hasOtherItems () {
      return this.fieldOptions.length;
    },
    fieldOtherItems () {
      if (!this.hasOtherItems) return [];

      return this.otherOptions;
    },
    fieldGenericModel: {
      get () {
        if (this.questionData[this.questionFields.field] === null) return null;

        if (this.fieldOptions) {
          const isFieldOptionSelected = this.fieldOptions.some(op => op.value === this.questionData[this.questionFields.field]);
          return isFieldOptionSelected ? this.questionData[this.questionFields.field] : true;
        }

        return this.questionData[this.questionFields.field];
      },
      set (val) {
        this.questionData[this.questionFields.field] = val.logical ? val.logicalValue : val.value;
      },
    },
    isFieldOther () {
      return this.fieldGenericModel !== null && !this.fieldOptions.some(op => op.value === this.fieldGenericModel);
    },
  },
  methods: {
    async onSearch () {
      try {
        const response = await this.$api[this.searchType](this.payload);

        if (response.status !== 'success') throw new Error('Unsuccessful response status.');

        if (response.data?.default && Array.isArray(response.data.default)) {
          this.fieldOptions = this.prepareOptions(response.data.default);
        }
        if (response.data?.other && Array.isArray(response.data.other)) {
          this.otherOptions = this.prepareOptions(response.data.other);
        }
      } catch (error) {
        console.error(error);
      }
    },
    prepareOptions (source) {
      return source.map(item => ({
        value: this.convertKeysToNumbers ? +item.value : item.value,
        text: item.name,
      }));
    },
  },
};
</script>
